import { useState } from "react";
import { toast } from "sonner";
import { PayRailButtons } from "./payments/PayRailButtons";
import { loadRazorpay, redirectIfPhonePe } from "../lib/payRail";
import { formatINR } from "../lib/format";

// Retry an unpaid order from My Orders — customer picks Razorpay or PhonePe.
export function OrderRetryPay({ api, order, onPaid }) {
  const [busy, setBusy] = useState(false);
  if (order.payment_status === "paid" || order.status === "cancelled" || order.fulfillment_status === "cancelled") return null;

  const pay = async (rail) => {
    setBusy(rail);
    try {
      if (rail === "phonepe") {
        const { data } = await api.post(`/orders/${order.id}/pay/phonepe`);
        if (redirectIfPhonePe(data)) return;
        throw new Error("PhonePe could not open — please choose Pay via Razorpay.");
      }
      const { data } = await api.post(`/orders/${order.id}/pay/razorpay`);
      const ok = await loadRazorpay();
      if (!ok) throw new Error("Could not load Razorpay. Retry.");
      const rz = new window.Razorpay({
        key: data.key_id, amount: data.amount_paise, currency: data.currency, order_id: data.order_id,
        name: "Vinci Inc.", description: `Order ${order.id.slice(0, 8).toUpperCase()}`, theme: { color: "#B87333" },
        prefill: { name: order.shipping_name || "", email: order.buyer_email || "", contact: order.shipping_phone || "" },
        handler: async (rp) => {
          try {
            await api.post(`/orders/${order.id}/verify`, { razorpay_order_id: rp.razorpay_order_id, razorpay_payment_id: rp.razorpay_payment_id, razorpay_signature: rp.razorpay_signature });
            toast.success("Payment received — order confirmed.");
            onPaid && onPaid();
          } catch { toast.error("Payment verification failed. Contact support with your payment ID."); }
          finally { setBusy(false); }
        },
        modal: { ondismiss: () => setBusy(false) },
      });
      rz.open();
    } catch (e) { toast.error(e?.response?.data?.detail || e.message || "Could not start payment"); setBusy(false); }
  };

  return (
    <div data-testid={`order-retry-pay-${order.id}`} className="mt-4 border border-[#D8B23E]/30 bg-[#D8B23E]/[0.04] rounded-sm p-4">
      <div className="font-grotesk text-[9px] uppercase tracking-[0.28em] text-[#D8B23E] mb-3">Payment pending · complete this order</div>
      <div className="max-w-sm">
        <PayRailButtons compact testId={`order-retry-${order.id}`} onPay={pay} busy={busy} amountLabel={formatINR(order.total)}
                        note="Either rail confirms the order instantly once payment is verified." />
      </div>
    </div>
  );
}
